import React from "react";

import { useQuery } from "@apollo/client";

// import TrendTableDx from "./trend-table-dx";
// // import TrendTableZingGrid from './trend-table-zinggrid';

// import { allData as allDataFn } from "./trend-graph-utils";

// const PanelTableMetaData = loader("../graphql/PanelTableMetaData.graphql");

// const TrendValues = loader("../graphql/TrendValues.graphql");
import panelTable from "./panel-table-query";
import LiveDataTable from "./livedata-table-mui";

import { trendDurationVar } from "../../reactive-variables";
import { useReactiveQueryParam } from "../../use-reactive-query-params";

interface Props {
  nodes?: any[];
  panelCollectionName: string;
  // panelId?: string;
  // panelName: String;
  panelDefinition: any;
  // startDate: number; // Date;
  // endDate: number; // Date;
  // widgetStatic?: boolean;
  // widgetTitle?: string;
}

function PanelTableContainer(props: Props) {
  // startDate={data.durationSelect && data.durationSelect.startDate || '2010-01-01T00:00:00.00Z'} endDate={data.durationSelect && data.durationSelect.endDate || '2020-01-01T00:00:00.00Z'}
  const {
    nodes,
    panelCollectionName,
    // panelId,
    // panelName,
    panelDefinition,
    // startDate,
    // endDate,
    // widgetStatic,
    // widgetTitle,
  } = props;
  // const [trendDuration, setTrendDuration] = useState<string | null>();
  const trendDurationReactiveVar = useReactiveQueryParam(
    "trendduration",
    trendDurationVar
  );
  const n = nodes ? nodes.join(",") : undefined;
  const { data, error: metaError, loading: metaLoading } = useQuery(
    panelTable,
    {
      variables: {
        panelCollectionName: panelCollectionName,
        panelName: panelDefinition?.template,
        tab: panelDefinition?.id,
        node: n,
      },
    }
  );
  // const {
  //   data: dataSeries,
  //   error: valuesError,
  //   loading: valuesLoading,
  // } = useQuery(TrendValues, {
  //   variables: { panelId, nodes: n, startDate, endDate },
  // });
  if (metaLoading) {
    return <div>Loading...</div>;
  }
  if (metaError) {
    console.error(metaError.message);
    return <div>Error! {metaError.message}</div>;
  }
  // if (valuesLoading) {
  //   return <div>Loading...</div>;
  // }
  // if (valuesError) {
  //   console.error(valuesError.message);
  //   return <div>Error! {valuesError.message}</div>;
  // }
  // console.log("panel table data", data);
  return (
    <LiveDataTable
      metaData={data.table}
      leftColumns={["index_0"]} // TODO naming
      tableColumnExtensions={[
        { columnName: "index_0", align: "left", width: 200 },
        ...data.table.columns.slice(1).map((column: any, columnIndex: any) => ({
          columnName: column.headerData.content || `index_${columnIndex + 1}`,
          align: "right",
        })),
      ]}
      trendDuration={trendDurationReactiveVar()}
      onTrendDurationChange={(newTrendDuration) => {
        trendDurationReactiveVar(newTrendDuration);
      }}
    />
  );

  // const allData = allDataFn(data.metaData);
  // // const chartData = mergeSeries(dataSeries.dataSeries).sort(
  // //   (a, b) => b.time - a.time
  // // );
  // return (
  //   <TrendTableDx
  //     // nodes={nodes}
  //     allData={allData}
  //     metaData={data.metaData}
  //     // chartData={chartData}
  //     // dataSeries={dataSeries.dataSeries}
  //     widgetStatic={widgetStatic}
  //     widgetTitle={widgetTitle}
  //     nodes={nodes}
  //     panelId={panelId}
  //     startDate={startDate}
  //     endDate={endDate}
  //   />
  // );
}

export default PanelTableContainer;
